import { render, staticRenderFns } from "./InitialBookNewData.vue?vue&type=template&id=94b31afc&scoped=true"
import script from "./InitialBookNewData.vue?vue&type=script&lang=ts"
export * from "./InitialBookNewData.vue?vue&type=script&lang=ts"
import style0 from "./InitialBookNewData.vue?vue&type=style&index=0&id=94b31afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b31afc",
  null
  
)

export default component.exports